/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { buildTranslationPackage, TranslationPackage } from './TranslationPackage';
export { TranslationPackage, buildTranslationPackage };
export var UIElement;
(function (UIElement) {
    UIElement["NEW_SHEET_PREFIX"] = "NEW_SHEET_PREFIX";
})(UIElement || (UIElement = {}));
